import { UserPlus, Truck, Receipt } from 'lucide-react';
import { PageTour } from '@/components/common/PageTour';

/**
 * 3-step Suppliers walkthrough — covers the canonical supplier flow:
 *   1. Add a supplier (with credit limit + tax info)
 *   2. Log a delivery / credit purchase
 *   3. Reconcile a payment (cash / bank / partial credit)
 *
 * Triggered by the Suppliers info callout's "Show me around" button.
 */
const STEPS = [
  {
    icon: UserPlus,
    title: '1. Add a supplier',
    body: (
      <>
        Click <strong>+ Add Supplier</strong> and fill in the basics — name, contact, VAT/tax number, and an
        optional <strong>credit limit</strong> so the system warns you before a balance breaches it. You can
        also assign default categories so future bills auto-categorise (e.g. &quot;Saudi Aramco → Fuel&quot;).
      </>
    ),
  },
  {
    icon: Truck,
    title: '2. Log a delivery / credit purchase',
    body: (
      <>
        When the goods arrive, create an expense or supplier-bill against this supplier with payment method
        <strong> Credit</strong>. Their <strong>Current Credit</strong> field updates automatically; you&apos;ll see
        unpaid invoices in the supplier detail page. You can attach the bill PDF / image so audits are clean.
      </>
    ),
  },
  {
    icon: Receipt,
    title: '3. Reconcile a payment',
    body: (
      <>
        Hit <strong>Pay from Bank</strong> on the supplier card and pick the bank account. The system applies
        FIFO against unpaid bills, drops the credit balance, and links the payment to the bank-statement line
        when you reconcile. Use the <strong>Cash flow movers</strong> panel up top to spot suppliers whose
        payment volume changed sharply — early warning on rate hikes or relationship issues.
      </>
    ),
  },
];

export function SuppliersTour({ open, onOpenChange }) {
  return (
    <PageTour
      open={open}
      onOpenChange={onOpenChange}
      steps={STEPS}
      tourName="Suppliers walkthrough"
      testidPrefix="suppliers-tour"
    />
  );
}
